import { CurrencyPipe } from '@angular/common';

export const ZERO_AMOUNT = '0,00\u00a0€';

export const formatMoney = (value: number, withEuroSign = false, maxDecimalDigits = 2) =>
  new CurrencyPipe('de-DE').transform(
    value,
    'EUR',
    withEuroSign ? 'symbol' : '',
    `1.2-${maxDecimalDigits}`,
  );
